<template>
  <div v-if="folder">
    <h1>Folder</h1>
    <p>
      <v-btn :to="{name:'folders'}">
        <v-icon>chevron_left</v-icon>&#160;Folders
      </v-btn>
    </p>
    <h2>
      <span>{{folder.name}}</span>
      <span>&#160;</span>
      <router-link :to="{name:'folderEdit', params:{id:folder.id}}">Edit</router-link>
    </h2>
    <p>
      <b:switch
        value="#{folderBean.archived}"
        label="#{msg.folder7}"
        onchange="ajax:folderBean.update()"
        offText="Active"
        onText="Archived"
        offColor="success"
        onColor="info"
        update="@form"
      />
    </p>
    <h3>Responses</h3>
    <p>
      <v-btn :to="{name:'response', query:{folderid:$route.params.id}}">
        Create new&#160;
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </p>
    <v-data-table
      :headers="headers"
      :items="responses"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      v-if="responses"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{name:'response', params:{ id:props.item.id },query:{ clone:false }}"
              small
            >{{props.item.id}}</v-btn>
          </td>
          <td>{{ props.item.body }}</td>
          <td>
            <v-btn
              :to="{name:'response', params:{ id:props.item.id }, query:{ clone:true }}"
              small
            >Clone</v-btn>
          </td>
          <td>
            <v-btn @click="archive(props.item, true)" v-if="!props.item.archived" small>Archive</v-btn>
            <v-btn @click="archive(props.item, false)" v-if="props.item.archived" small>Unarchive</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Folder",
  metaInfo() {
    return {
      title: "Folder",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      folder: null,
      responses: null,
      headers: [
        {
          text: "Response Id",
          value: "id"
        },
        {
          text: "Body",
          value: "body"
        },
        {
          text: " ",
          value: "id"
        },
        {
          text: " ",
          value: "id"
        }
      ],
      pagination: {
        sortBy: "body",
        descending: false,
        page: 1,
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchFolder() {
      nbmlaw
        .get(`/cors/admin/message/folders/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.folder = response.data;
        })
        .catch(() => {});
    },
    fetchResponses() {
      nbmlaw
        .get(`/cors/admin/message/folders/${this.$route.params.id}/responses`)
        .then(response => {
          // console.log(response.data);
          this.responses = response.data;
        })
        .catch(() => {});
    },
    archive(responseObject, archive) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .put(
            `/cors/admin/message/responses/${responseObject.id}/archive/${archive}`,
            null
          )
          .then(() => {
            // console.log(response.data);
            this.fetchResponses();
          })
          .catch(() => {});
      }
    }
  },
  created() {
    this.fetchFolder();
    this.fetchResponses();
  }
};
</script>